export class GetAllAnswers {
    public static readonly type = '[KbItems] Get All Answers';
}
